import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../src/assets/styles/main.css"
import "../src/assets/styles/color.css"
import "../src/assets/styles/responsive.css"
import "../src/assets/styles/custom.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter as Router } from "react-router-dom";
import { useEffect } from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";
import Footer from './components/common/Footer';
import Navbar from './components/common/Navbar';
import AllRoutes from './AllRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MoveToTop from './components/common/MoveToTop';
import CookieConsent from "react-cookie-consent"; 

function App() {

  useEffect(() => {
    Aos.init({
      offset: 100, // offset (in px) from the original trigger point
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-out",
      once: false,
    });
  }, []); 

  return (
    <div className="App"> 

      <Router>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        // transition:Bounce,
        />
        <Navbar />
        <MoveToTop />
        <AllRoutes />
        <Footer />
      </Router>

      {/* TEMP: hidden to test DM team's GA4 theory - restore after confirming
          cookie banner is not the cause (2026-09-22)
      <CookieConsent
        location="bottom"
        enableDeclineButton
        buttonText="I Accept"
        cookieName="cookieConsent"
        style={{ background: "#000", alignItems: 'center', padding: "12px" }}
        buttonStyle={{ background: "#01922f", color: "#fff", fontSize: "16px" }}
        expires={150}
      >
        <div style={{ fontSize: '20px', marginBottom: '5px' }} >This website uses cookies to enhance the user experience. </div>
        <div style={{ fontSize: '13px', color: "#01922f", lineHeight: '18px' }}>
          We use essential cookies to ensure the proper functioning of our website and improve your browsing experience. <br /> By continuing to use this site, you agree to our use of cookies.
        </div>
      </CookieConsent>
      */}
    </div>
  );
}

export default App;
